import withCuratorDetails from 'modules/Curator/hoc/withCuratorDetails';
import { CuratorPage as CuratorPageComponent } from './CuratorPage';

export const CuratorPage = withCuratorDetails(CuratorPageComponent);
